export const fileUploadSelector = (state, formKey, formField) =>
    state.fileuploads.uploads[`${formKey}.${formField}`];

export const fileUploadInProgressSelector = (state, formKey) =>
    Object.entries(state.fileuploads.uploads).find(
        ([key, upload]) => key.startsWith(`${formKey}.`) && upload && upload.loading
    ) !== undefined;

export const maxUploadFilesizeSelector = state => state.fileuploads.maxUploadFilesize;
